













































































































import {
  defineComponent,
  computed,
  ref,
  useRouter,
  useRoute,
  watch,
} from "@nuxtjs/composition-api";
import {
  useConfigStore,
  useLuckyWheelStore,
  useVoucherStore,
} from "~/stores/extensionApi";
import { useUser } from "~/modules/customer/composables/useUser";
import { decodeUid, changeImage, copyCode, checkHttpLink } from "~/helpers";
import { useUiNotification } from "~/composables";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { useClevertapStore } from "~/stores/clevertap";
import { usePageStore } from "~/stores/page";

export default defineComponent({
  name: "PopupModal",
  components: {},
  props: {
    isPopUp: {
      type: Object,
      default: null,
    },
    typePage: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { routeData } = usePageStore();
    const router = useRouter();
    const route = useRoute();
    const luckyWheelStore = useLuckyWheelStore();
    const configStore = useConfigStore();
    const countShowPopup = computed(() => configStore.getCountShowPopup);
    const { isAuthenticated, user: userCurrent } = useUser();
    const voucherStore = useVoucherStore();
    const { send: sendNotification } = useUiNotification();
    const { activeCategoryById } = useTraverseCategory();
    const clevertapStore = useClevertapStore();

    const activeCategoryByUid = computed(() => {
      return activeCategoryById(decodeUid(routeData?.uid));
    });

    const pageId = ref(null);
    const imagePopupMobile = computed(() => {
      return props.isPopUp?.image_mobile
        ? changeImage(props.isPopUp.image_mobile)
        : "";
    });

    const getUserCheckWinWheel = computed(() => {
      return luckyWheelStore.getUserCheckWinWheel;
    });

    const codeVoucherPopup = ref(null);
    const checkClose = ref(false);
    const checkWinWheel = ref(false);

    const screenForPopup = async () => {
      if (props.isPopUp?.game_codes) {
        luckyWheelStore.setGameCode(props.isPopUp.game_codes);
        if (!isAuthenticated.value) {
          checkWinWheel.value = false;
          checkPopUpNotWinWeel();
          return;
        } else if (isAuthenticated.value && userCurrent.value) {
          if (props.typePage == "HOME") {
            let phone = userCurrent.value?.phone_number;
            let data = {
              phone,
              game_codes: luckyWheelStore.getGameCodes,
            };
            let check = await luckyWheelStore.setInforWinWheel(data);
            if (check) {
              checkWinWheel.value = true;
            } else {
              checkWinWheel.value = false;
              checkPopUpNotWinWeel();
            }
          } else {
            checkWinWheel.value = false;
            checkPopUpNotWinWeel();
            return;
          }
        }
      } else {
        await checkPopUpNotWinWeel();
      }
    };

    const adsParams = route.value.query?.ads_params || null;
    const count = ref(0);

    const checkPopUpNotWinWeel = async () => {
      checkWinWheel.value = false;

      let checkDataPopupAllPage = props.isPopUp?.location.includes("all_page");
      if (checkDataPopupAllPage) {
        await getCodePopup();
        if (props.isPopUp?.rule_id && !codeVoucherPopup.value) {
          return;
        }
        checkClose.value = true;
        count.value += 1;
        configStore.setCountShowPopup(count.value);
      } else {
        let arr = props.isPopUp?.location
          ? props.isPopUp?.location?.split(",")
          : [];

        if (arr && arr.length > 0) {
          for (const element of arr) {
            if (props.typePage == element.toUpperCase()) {
              await getCodePopup();
              if (props.isPopUp?.rule_id && !codeVoucherPopup.value) {
                return;
              }
              if (element.toUpperCase() === "CATEGORY") {
                checkCategory(props.isPopUp);
              } else if (element.toUpperCase() === "LANDING") {
                checkLandingPage(props.isPopUp);
              } else if (element.toUpperCase() === "PRODUCT") {
                checkProductDetail(props.isPopUp);
              } else {
                checkAnother(props.isPopUp);
              }
            }
          }
        }
      }
    };

    const checkCategory = (dataPopUp) => {
      let arr = dataPopUp?.category_ids
        ? dataPopUp.category_ids.split(",")
        : [];

      let check = arr?.includes(pageId.value?.toString());
      let checkDataPopupAllPage = dataPopUp?.location?.includes("all_page");

      if (check || checkDataPopupAllPage) {
        if (dataPopUp?.delay_time) {
          setTimeout(() => {
            checkClose.value = true;
          }, parseFloat(props.isPopUp?.delay_time) * 1000);
        }
        checkClose.value = true;
        count.value += 1;
        configStore.setCountShowPopup(count.value);
      }
    };

    const checkLandingPage = (dataPopUp) => {
      let arr = dataPopUp?.landing_ids ? dataPopUp.landing_ids.split(",") : [];
      let check = arr.filter((e) => e == pageId.value);
      let checkDataPopupAllPage = dataPopUp?.location?.includes("all_page");
      if ((check.length > 0 && check) || checkDataPopupAllPage) {
        if (dataPopUp?.delay_time) {
          setTimeout(() => {
            checkClose.value = true;
          }, parseFloat(props.isPopUp?.delay_time) * 1000);
        } else {
          checkClose.value = true;
        }
        count.value += 1;
        configStore.setCountShowPopup(count.value);
      }
    };

    const checkProductDetail = (dataPopUp) => {
      let arr = dataPopUp?.product_ids ? dataPopUp.product_ids.split(",") : [];
      let check = arr.filter((e) => e == pageId.value);
      let checkDataPopupAllPage = dataPopUp?.location?.includes("all_page");
      if ((check.length > 0 && check) || checkDataPopupAllPage) {
        if (dataPopUp?.delay_time) {
          setTimeout(() => {
            checkClose.value = true;
          }, parseFloat(props.isPopUp?.delay_time) * 1000);
        } else {
          checkClose.value = true;
        }
        count.value += 1;
        configStore.setCountShowPopup(count.value);
      }
    };

    const checkAnother = (dataPopUp) => {
      if (!isAds.value) return;

      let checkDataPopupAllPage = dataPopUp?.location?.includes("all_page");
      let check = dataPopUp?.location?.includes("home");

      if (check || checkDataPopupAllPage) {
        if (dataPopUp?.delay_time) {
          setTimeout(() => {
            checkClose.value = true;
          }, parseFloat(props.isPopUp?.delay_time) * 1000);
        }
        checkClose.value = true;
        count.value += 1;
        configStore.setCountShowPopup(count.value);
      }
    };

    const isCountDown = computed(() => {
      const locationString = props.isPopUp?.location || "";
      let arr = locationString ? locationString.split(",") : [];
      if (arr.length === 0) {
        return false;
      }
      if (arr.includes("all_page")) {
        return true;
      }
      if (arr.includes("home") && props.typePage === "HOME") {
        return true;
      }
      if (
        arr.includes("category") &&
        props.typePage === "CATEGORY" &&
        pageId.value
      ) {
        const categoryIds = props.isPopUp?.category_ids || "";
        let categoryArr = categoryIds ? categoryIds.split(",") : [];
        if (categoryArr.includes(pageId.value.toString())) {
          return true;
        }
        return false;
      }
      return false;
    });

    const isAds = computed(() => {
      if (props.isPopUp?.ads_param == "ads") {
        if (adsParams == "1") {
          return true;
        } else {
          return false;
        }
      } else if (props.isPopUp?.ads_param == "") {
        if (adsParams != "1") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });

    const getCodePopup = async () => {
      if (countShowPopup.value > 0) return;
      let rule_id = props.isPopUp ? props.isPopUp?.rule_id : null;
      if (rule_id && isCountDown.value) {
        codeVoucherPopup.value = await voucherStore.getCodeVoucher(rule_id);
      }
    };

    const isGetVoucher = ref(false);

    const trackPopupPromotion = () => {
      if (typeof window == "undefined" ) return;
      if (!props.isPopUp) return;
      const dataPopupPromotion = {
        promotion_name: props.isPopUp.name || "",
        promotion_id: props.isPopUp.entity_id || "popup_promotion",
        voucher_code: codeVoucherPopup.value || null,
        get_voucher: isGetVoucher.value,
      };

      if (window.clevertap) {
        clevertapStore.popupPromotionCleverTap({
          clevertap: window.clevertap,
          data: dataPopupPromotion,
        });
        isGetVoucher.value = false;
      }
    };

    watch(
      () => route.value,
      async () => {
        if (route.value?.path == "/") {
          pageId.value = 2;
        } else if (activeCategoryByUid.value) {
          pageId.value = activeCategoryByUid.value?.uid
            ? decodeUid(activeCategoryByUid.value.uid)
            : null;
        }

        if (props.isPopUp) {
          await screenForPopup();
        }
      },
      { immediate: true }
    );

    watch(
      () => userCurrent.value,
      async (newVal, oldVal) => {
        if (!newVal) return;
        if (props.isPopUp?.game_codes && newVal != oldVal) {
          await screenForPopup();
        }
      },
      { immediate: true }
    );

    watch(
      () => countShowPopup.value,
      (newVal) => {
        if (newVal == 1 && checkClose.value && props.isPopUp) {
          // tracking Popup Promotion
          trackPopupPromotion();
        }
      }
    );

    const closePopup = () => {
      emit("close");
      checkClose.value = false;
      // config clevertap
    };

    const handleCopyCode = (code: string) => {
      let message = `Bạn đã copy mã ${code}`;
      copyCode(code);

      sendNotification({
        id: Symbol("copy_text_success"),
        message: message,
        type: "success",
        icon: "check",
        persist: false,
        title: message,
      });
      isGetVoucher.value = true;
      trackPopupPromotion();
    };

    const gotoWinWheel = () => {
      emit("close");
      checkClose.value = false;
      router.push("/ma-uu-dai");
    };

    return {
      checkClose,
      getUserCheckWinWheel,
      changeImage,
      closePopup,
      codeVoucherPopup,
      handleCopyCode,
      gotoWinWheel,
      countShowPopup,
      imagePopupMobile,
      checkHttpLink,
    };
  },

  head() {
    return {
      link: this.imagePopupMobile
        ? [
            {
              rel: "preload",
              as: "image",
              href: this.imagePopupMobile,
            },
          ]
        : [],
    };
  },
});
